import { AddRounded, ExpandLess, ExpandMore, KeyboardArrowUp, PersonRounded } from "@mui/icons-material";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import {
	attrConditionalDisplayColObj,
	attrGrpTableStrColumnsObj,
	constraintsOptions,
	isColumnDefault,
	selectedShootPagepath,
} from "components/PimDashboard/data";
import { studioAttrGroupLinkedTables } from "../StudioAttributeGroups/data";
import { AuthState } from "context/AuthContext";
import { inputTypes, statusOptions } from "data/globalData";
import { studioAttrGrpAttrAssocObj, studioAttrValAssocObj } from "../StudioAttributes/data";
import { useEffect, useState } from "react";
import axios from "axios";
import RenderAttributeInputs, { removeDropdownOptionsBasedonDependency } from "./RenderAttributeInputs/RenderAttributeInputs";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import RenderStyleInputField from "./RenderStyleInputFieldNU/RenderStyleInputField";
import AddNewImageModal, { isMainImg } from "./AddImagesModal/AddImagesModal";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { departments } from "data/authData";
import { useNavigate } from "react-router-dom";
import {
	NAOption,
	fileColumns,
	shootFileAssocObj,
	shootImagesAssocObj,
	shootSkuAssocObj,
	shootUrlKey,
	studioCollectionTypes,
	styleFileUrlKey,
	styleImgDepartmentCol,
	styleUrlKey,
} from "./data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { StudioDashboardState } from "context/StudioDashboardContext";
import ModalSection from "./ModalSection/ModalSection";
import SkuSection from "./SkuSection/SkuSection";
const imgWidth = 150;
const imgHeight = 180;

const RenderConditionalAttributeInputs = ({ columns, setData, data, width, attrGrp, setErrorObj, errorObj }) => {
	const { allAttributes } = StudioDashboardState();
	const condGrpAttrColkey = attrGrp?.data?.[attrConditionalDisplayColObj.key];
	let colCondAttr = null;
	if (condGrpAttrColkey && allAttributes) {
		let arr = allAttributes.filter((row) => row?.key === condGrpAttrColkey);
		if (arr?.length) colCondAttr = arr[0];
	}
	console.log(colCondAttr, condGrpAttrColkey, "fdghjk");
	useEffect(() => {
		if (colCondAttr) {
			let condAttrColVal = data?.[colCondAttr?.linked_table]?.[condGrpAttrColkey]
				? data?.[colCondAttr?.linked_table]?.[condGrpAttrColkey]
				: "";
			console.log(colCondAttr, condGrpAttrColkey, condAttrColVal, currentConditionalAttr, "fdghjksdf");

			if (condAttrColVal !== currentConditionalAttr) {
				if (condAttrColVal !== getColDefaultValue(colCondAttr)) {
					let a1 = [],
						a2 = [],
						a2DefValues = {},
						a1DefValues = {};
					columns?.forEach((col) => {
						console.log(
							col,
							col?.data?.[attrConditionalDisplayColObj.key]?.includes(
								data?.[colCondAttr.linked_table]?.[colCondAttr.key]
							),
							"fdghjk1"
						);
						if (
							col?.data?.[attrConditionalDisplayColObj.key]?.includes(
								data?.[colCondAttr.linked_table]?.[colCondAttr.key]
							)
						) {
							a1.push(col);
						} else {
							a2.push(col);
							if (Array.isArray(data[col.linked_table]?.[col.key])) a2DefValues[col.key] = [NAOption];
							else a2DefValues[col.key] = NAOption;
						}
					});
					setCurrentConditionalAttr(condAttrColVal);
					setArr1(a1);
					setArr2(a2);
					setData({ ...data, [attrGrp.linked_table]: { ...data[attrGrp.linked_table], ...a2DefValues } });
				} else setArr1(columns);
			}
		} else setArr1(columns);
	}, [data]);
	const [arr1, setArr1] = useState([]);
	const [arr2, setArr2] = useState([]);
	const [viewAll, setViewAll] = useState(false);
	const [currentConditionalAttr, setCurrentConditionalAttr] = useState();
	const handleShowAllClick = () => {
		setViewAll(!viewAll);
	};
	return (
		<Box width="100%">
			<Box
				display="flex"
				width={width ? width : "100%"}
				flexWrap="wrap"
				p={1}
				alignItems="flex-start"
				columnGap="1%"
				rowGap="2px">
				{arr1?.map((column) => {
					console.log(column, "[attrGrpId][attrGrpId]");

					let options = {};
					options = removeDropdownOptionsBasedonDependency(column, data, column?.[studioAttrValAssocObj], allAttributes);

					return (
						<RenderStyleInputField
							column={{ ...column, [studioAttrValAssocObj]: options }}
							data={data}
							setData={setData}
							selectOptObjName={studioAttrValAssocObj}
							width={"24%"}
							longWidth={"48%"}
							// dependencyColData={}
							attrGrp={attrGrp}
							error={errorObj}
							setError={setErrorObj}
						/>
					);
				})}
			</Box>
			<Box display="flex" justifySelf="end">
				<Button
					sx={{ marginLeft: "auto" }}
					onClick={handleShowAllClick}
					endIcon={viewAll ? <ExpandLess fontSize="large" /> : <ExpandMore fontSize="large" />}>
					View {viewAll ? "Less" : "All"}
				</Button>
			</Box>
			<Box
				display={viewAll && arr2?.length ? "flex" : "none"}
				width={width ? width : "100%"}
				flexWrap="wrap"
				p={1}
				alignItems="flex-start"
				columnGap="1%"
				rowGap="2px">
				{arr2?.map((column) => {
					console.log(column, "[attrGrpId][attrGrpId]");
					let options = {};
					options = removeDropdownOptionsBasedonDependency(column, data, column?.[studioAttrValAssocObj], allAttributes);

					return (
						<RenderStyleInputField
							column={{ ...column, [studioAttrValAssocObj]: options }}
							data={data}
							setData={setData}
							selectOptObjName={studioAttrValAssocObj}
							width={"24%"}
							longWidth={"48%"}
							// dependencyColData={}
							attrGrp={attrGrp}
							error={errorObj}
							setError={setErrorObj}
						/>
					);
				})}
			</Box>
		</Box>
	);
};
const CreateShoot = () => {
	const pageName = "Shoot";
	const { user } = AuthState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes, setSelectedShoot } = StudioDashboardState();
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();

	const navigate = useNavigate();

	const [newDetails, setNewDetails] = useState(() => {
		let obj = {};
		allAttributes
			.filter((row) => row.collection_type === studioCollectionTypes.SHOOTS.key)
			.forEach((attr) => {
				if (!obj[attr?.linked_table]) obj[attr?.linked_table] = {};
				obj[attr?.linked_table][attr?.key] = getColDefaultValue(attr);
			});
		return obj;
	});
	const [pageFiles, setPageFiles] = useState([]);
	const [errobj, setErrorObj] = useState({});
	const [images, setImages] = useState([]);
	const [selectedSkus, setSelectedSkus] = useState([]);
	const [selectedModelProfile, setSelectedModelProfile] = useState();
	const [imgModalOpen, setImgModalOpen] = useState(false);
	const handleAddImageClick = () => {
		setImgModalOpen(true);
	};
	const handleSaveImgClick = (Images) => {
		setImages([...Images]);
		return true;
	};
	const handleFileUpload = async (images, pageFiles) => {
		// append formdata with multiple file and its name

		const uploadImgs = async () => {
			const formData = new FormData();
			images?.forEach((image) => {
				formData.append("shootImages", image.file);
			});

			const res = await axios.post("/api/studio/upload_shoot_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			});

			return res.data.result;
		};
		const uploadFiles = async () => {
			if (pageFiles?.length) {
				const fileFormData = new FormData();

				pageFiles?.forEach((fileData) => {
					fileFormData.append("files", fileData[fileColumn.key]);
					fileFormData.append("fileMeta", JSON.stringify(fileData)); // corresponding metadata
				});
				const res = await axios.post("/api/upload/multiple_upload_to_rel_bucket", fileFormData, {
					headers: {
						"content-type": "multipart/form-data",
					},
				});
				return res.data.result;
			}
			return new Promise((resolve, reject) => {
				resolve([]);
			});
		};
		const [modalProfileImgs, uploadedFiles] = await Promise.all([uploadImgs(), uploadFiles()]);

		return [modalProfileImgs, uploadedFiles];
	};

	const handleFormSubmit = async () => {
		setLoadingOpen(true);
		if (images.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one image",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		if (selectedSkus.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one color",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		if (!selectedModelProfile) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Select Model Profile",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			return;
		}
		let pendingFields = [];
		allAttributes
			.filter(
				(row) =>
					row?.linked_table === studioAttrGroupLinkedTables.shoot.key && row?.input_type !== inputTypes.AUTO_GENERATE.key
			)
			.forEach((attr) => {
				let obj = newDetails;
				if (obj[attr?.linked_table])
					if (
						isColumnDefault(attr, obj?.[attr?.linked_table]?.[attr?.key]) &&
						attr?.constraints[constraintsOptions.NOTNULL.key]
					)
						pendingFields.push(attr);
			});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		const sysData = {
			last_updated_by: user?.email,
			created_by: user?.email,
			// stage: productionStageOptions.DESIGNER.key,
			status: statusOptions.CREATED.key,
		};

		try {
			let [shootImages, uploadedFiles] = await handleFileUpload(images, pageFiles);
			console.log(shootImages, "gasddfghjfdghjk");

			// finding main Img Url
			images.forEach((row, i) => {
				console.log(images, shootImages, "jkshfsandgfhjjjkkkkk");
				if (row[isMainImg] === true) {
					shootImages[i][isMainImg] = true;
					shootImages[i]["url"] = shootImages[i]["publicUrl"];
				}
			});

			uploadedFiles = uploadedFiles.map((row) => {
				let dup = { ...row };
				delete dup["id"];
				return dup;
			});

			const body = newDetails;
			// for joining color & images

			// for joining shoot & images
			body[studioAttrGroupLinkedTables.shoot.key] = {
				...body[studioAttrGroupLinkedTables.shoot.key],
				...sysData,
				modal_profile_id: selectedModelProfile.modal_profile_id,
				[shootImagesAssocObj]: shootImages,
				[shootFileAssocObj]: uploadedFiles,
				[shootSkuAssocObj]: selectedSkus,
			};

			// console.log("stylesty", body);

			const res = await axios.post("/api/studio/create_shoot", body);
			console.log("res.data", res.data);
			setSelectedShoot();
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Created ${pageName} successfully`,
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			navigate(`/${selectedShootPagepath}?${shootUrlKey}=${res.data.shoot_id}`);
			setLoadingOpen(false);
		} catch (error) {
			console.log(error, "ddsfdghjkl");
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
		}
	};

	const handleDesignerFileAdd = async (newFileData) => {
		setPageFiles((prev) => [...prev, { ...newFileData, [styleFileUrlKey]: "To be Uploaded" }]);
		return true;
	};

	async function handleDesignerFileDelete(fileData) {
		setPageFiles((prev) => prev.filter((row) => row?.id !== fileData?.id));
		return true;
	}

	return (
		<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
			<Stack>
				<Box display="flex" columnGap={1}>
					<Typography ba variant="subtitle1">
						User :
					</Typography>
					<PersonRounded />
					<Typography ba variant="subtitle1">
						{user.name}
					</Typography>
				</Box>
			</Stack>
			<Box
				display="flex"
				alignItems="center"
				height="30px"
				columnGap={1}
				sx={{
					backgroundColor: statusOptions["NEW"]?.color || yellow[400],
					color: "white",
					padding: "5px",
					borderRadius: "5px",
				}}>
				{statusOptions["NEW"]?.icon} <Typography> {statusOptions["NEW"]?.name}</Typography>
			</Box>
			<Divider variant="fullWidth" orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />

			{/* shoot Table Columns */}
			{Object.keys(attrGroupsWithAttr)
				.reduce((acc, row) => {
					if (attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] === studioAttrGroupLinkedTables.shoot.key)
						acc.push(attrGroupsWithAttr[row]);
					return acc;
				}, [])
				?.map((row) => {
					return (
						<Box width="100%" pt={2}>
							<Typography variant="h6">{row[attrGrpTableStrColumnsObj.name.key]}</Typography>
							{row?.data?.[attrConditionalDisplayColObj.key] ? (
								<RenderConditionalAttributeInputs
									columns={[...row[studioAttrGrpAttrAssocObj]]}
									setData={setNewDetails}
									data={newDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							) : (
								<RenderAttributeInputs
									columns={[...row[studioAttrGrpAttrAssocObj]]}
									setData={setNewDetails}
									data={newDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							)}
						</Box>
					);
				})}

			<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1, mb: 1 }} />
			<Box display="flex" justifyContent="space-around" width="100%">
				{/* left */}
				<Stack>
					<Box display="flex" width="100%" pb={1} justifyContent="space-between">
						<Typography variant="h6">Images</Typography>
						{images?.length > 0 && (
							<Button
								sx={{ textTransform: "capitalize" }}
								onClick={handleAddImageClick}
								size="small"
								startIcon={<AddRounded />}
								variant="outlined">
								Add / Set Main Images
							</Button>
						)}
					</Box>
					<Box
						width={imgWidth}
						height={imgHeight}
						sx={{ border: `1px solid ${grey[200]}` }}
						display="flex"
						alignItems="center"
						justifyContent="center">
						{images.length === 0 ? (
							<Box>
								<Button size="large" startIcon={<AddRounded />} onClick={handleAddImageClick}>
									Add Images
								</Button>
							</Box>
						) : (
							<Box width={imgWidth} height={imgHeight} display="flex" flexWrap="wrap" rowGap={2}>
								<ImageSlider imgWidth={imgWidth} imgHeight={imgHeight} column="url" images={images} />
							</Box>
						)}
						{/* */}
					</Box>
				</Stack>
				<Divider orientation="vertical" flexItem />
				{/* right */}
				<Box sx={{ width: "76%" }}>
					<ModalSection
						selectedModal={selectedModelProfile}
						setSelectedModal={setSelectedModelProfile}
						shootDetails={newDetails}
						disabled={false}
					/>
				</Box>
			</Box>
			<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />

			{/* shoot Details Table Columns */}
			{Object.keys(attrGroupsWithAttr)
				.reduce((acc, row) => {
					if (
						attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
						studioAttrGroupLinkedTables.shoot_details.key
					)
						acc.push(attrGroupsWithAttr[row]);
					return acc;
				}, [])
				?.map((row) => {
					return (
						<Box width="100%" pt={2}>
							<Typography variant="h6">{row[attrGrpTableStrColumnsObj.name.key]}</Typography>
							{row?.data?.[attrConditionalDisplayColObj.key] ? (
								<RenderConditionalAttributeInputs
									columns={[...row[studioAttrGrpAttrAssocObj]]}
									setData={setNewDetails}
									data={newDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							) : (
								<RenderAttributeInputs
									columns={[...row[studioAttrGrpAttrAssocObj]]}
									setData={setNewDetails}
									data={newDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							)}
						</Box>
					);
				})}

			{/* <Divider flexItem orientation="horizontal" sx={{ width: "100%", mt: 2 }} /> */}
			{/* files Section */}
			<Box mt={"20px"} />
			<SkuSection shootData={newDetails} selectedSkus={selectedSkus} setSelectedSkus={setSelectedSkus} />
			<Box pt={"20px"} />
			<Divider flexItem orientation="horizontal" sx={{ width: "100%", mt: 2 }} />

			<AddFiles
				addNewDefault={{ [styleImgDepartmentCol.key]: departments.STUDIO.key }}
				columns={fileColumns}
				handleAddFile={handleDesignerFileAdd}
				files={pageFiles}
				setFiles={setPageFiles}
				handleDelete={handleDesignerFileDelete}
			/>

			{/* <Divider flexItem orientation="horizontal" sx={{ width: "100%" }} /> */}

			{/* Submit Button */}
			<Box width="100%" display="flex" justifyContent="center" pb={2} pt={2}>
				<Button onClick={handleFormSubmit} variant="contained" margin="auto" size="large">
					Create {pageName}
				</Button>
			</Box>

			{/* add Images Modal */}
			{imgModalOpen && (
				<AddNewImageModal
					modalOpen={imgModalOpen}
					setModalOpen={setImgModalOpen}
					submitFunction={handleSaveImgClick}
					defaultImages={images}
				/>
			)}
		</Box>
	);
};

export default CreateShoot;
